import PIXI from 'pixi.js/src';
import data from './../data/data';
import config from './../config/config';
import renderHelper from './../helpers/render';
import frameAnimationHelper from './../helpers/frame-animation';
import router from './../router/router';
import 'whatwg-fetch';
import './../../vendor/greensock-js/src/uncompressed/TweenLite.js';

const shimmyView = {
  curryCount: 0,
  rowCount: 0,
  colCount: 0,


  /**
   * Sets up the view
   * @returns {undefined} undefined
   */
  init() {
    this.backgroundSquare = new PIXI.Graphics();
    this.backgroundSquare.beginFill(
      data.shimmyData.backgroundColor, 1);
    this.backgroundSquare.drawRect(
      0,
      0,
      window.innerWidth,
      window.innerHeight);
    renderHelper.stage.addChild(this.backgroundSquare);

    this.backgroundContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.backgroundContainer);

    this.graphicsContainer = new PIXI.Container();
    renderHelper.stage.addChild(this.graphicsContainer);

    this.messageText = new PIXI.Text('',
      {
        font: '18px ' + config.fontName,
        fill: config.whiteColor,
        align: 'center',
      }
    );
    this.messageText.resolution = 2;
    renderHelper.stage.addChild(this.messageText);

    this.resizeListener = this.onResize.bind(this);
    window.addEventListener('resize', this.resizeListener);
    window.addEventListener('orientationchange', this.resizeListener);

    this.horizontalDiv =
      Math.ceil(window.innerWidth / data.shimmyData.imageWidth);
    this.verticalDiv =
      Math.ceil(window.innerHeight / data.shimmyData.imageHeight);
    this.totalCount = this.horizontalDiv * this.verticalDiv;
    this.positionGraphics();
    this.addAnimation(0, 0);

    setTimeout(() => {
      router.navigate('leaderboard');
    }, 5000);
  },


  /**
   * Adds a Curry animation
   * @returns {undefined} undefined
   */
  addAnimation(x, y) {
    const _this = this;
    const animationContainer = new PIXI.Container();

    renderHelper.stage.addChild(animationContainer);

    frameAnimationHelper.create(
      animationContainer,
      data.shimmyData.imagePaths,
      data.shimmyData.animationTime,
      true,
      data.shimmyData.imageWidth,
      data.shimmyData.imageHeight);

    this.graphicsContainer.addChild(animationContainer);
    animationContainer.x = x;
    animationContainer.y = y;

    if (this.curryCount < this.totalCount) {
      this.curryCount++;
      this.colCount++;

      if (this.colCount === this.horizontalDiv) {
        this.colCount = 0;
        this.rowCount++;
      }

      setTimeout(() => {
        const xPos = _this.colCount * data.shimmyData.imageWidth;
        const yPos = _this.rowCount * data.shimmyData.imageHeight;

        _this.addAnimation(xPos, yPos);
      }, 50);
    }
  },


  /**
   * Positions graphics
   * @returns {undefined} undefined
   */
  positionGraphics() {
    this.backgroundSquare.height = window.innerHeight;
    this.backgroundSquare.width = window.innerWidth;
  },


  /**
   * Orientation change handler
   * @returns {undefined} undefined
   */
  onResize() {
    this.positionGraphics();
  },


  /**
   * Destroys the view
   * @returns {undefined} undefined
   */
  destroy() {
    window.removeEventListener('resize', this.resizeListener);
    window.removeEventListener('orientationchange', this.resizeListener);
    renderHelper.stage.removeChild(this.backgroundSquare);
    renderHelper.stage.removeChild(this.graphicsContainer);
  },
};

export default shimmyView;



/** WEBPACK FOOTER **
 ** ./assets/js/src/views/shimmy.js
 **/